import { render } from "./AssociateUser.vue?vue&type=template&id=8b9e7be6"
import script from "./AssociateUser.vue?vue&type=script&lang=js"
export * from "./AssociateUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/youth-elect.psppm.org.my/releases/69132554/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__